import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiConfiguration } from '@/core/api/api-configuration';
import { BaseService } from '@/core/api/base-service';
import { environment } from '@env/environment';
import { SICOM_PATHS } from 'src/sicom-paths';

import type { CancelamentoFalecimentoRequest, CancelamentoFalecimentoResponse } from './cancelamento-falecimento.model';

@Injectable({ providedIn: 'root' })
export class CancelamentoFalecimentoService extends BaseService {
    readonly PATH = SICOM_PATHS.servicos.pessoaFisica.cancelamentoFalecimento;

    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    consultar(params: CancelamentoFalecimentoRequest, context?: HttpContext): Observable<CancelamentoFalecimentoResponse> {
        const httpParams = new HttpParams().set('numeroProtocolo', params.numeroProtocolo).set('anoProtocolo', params.anoProtocolo).set('uf_crm', params.ufCrm);
        return this.http.get<CancelamentoFalecimentoResponse>(this.PATH, { params: httpParams, context });
    }

    consultarAbertos(ufCrm: string, context?: HttpContext): Observable<Record<string, unknown>[]> {
        const httpParams = new HttpParams().set('uf_crm', ufCrm);
        return this.http.get<Record<string, unknown>[]>(`${this.PATH}/abertos`, { params: httpParams, context });
    }

    efetivarSolicitacao(dto: CancelamentoFalecimentoResponse, context?: HttpContext): Observable<void> {
        return this.http.put<void>(`${this.PATH}/efetivarSolicitacao`, dto, { context });
    }

    cancelarSolicitacao(dto: CancelamentoFalecimentoResponse, motivo?: string, context?: HttpContext): Observable<void> {
        const params = motivo ? new HttpParams().set('motivo', motivo) : undefined;
        return this.http.put<void>(`${this.PATH}/cancelarSolicitacao`, dto, { params, context });
    }
}
